import classNames from 'classnames';
import Controls from './Controls';
import { CompanyList } from './Lists/CompanyList';
import { SiteList } from './Lists/SiteList';
import { StatusList } from './Lists/StatusList';
import {
    SiteSelectorContextProvider,
    useSiteSelectorContext,
} from './SiteSelectorContext';

const SiteSelectorInner = () => {
    const { groupBy } = useSiteSelectorContext();

    // trailing <div> provides space for the Zendesk widget
    return (
        <div className="w-full h-full hidden xxl:block">
            <Controls />

            <div
                className={classNames(
                    'flex flex-col gap-2 py-3',
                    groupBy === 'ungrouped' ? 'px-3' : 'px-2'
                )}
            >
                {groupBy === 'company' ? <CompanyList /> : null}
                {groupBy === 'status' ? <StatusList /> : null}
                {groupBy === 'ungrouped' ? <SiteList /> : null}
            </div>
            <div className="h-10"></div>
        </div>
    );
};

export const SiteSelector = ({ visible }: { visible?: boolean }) => (
    <SiteSelectorContextProvider visible={visible}>
        <SiteSelectorInner />
    </SiteSelectorContextProvider>
);
